import { Expose } from 'class-transformer';

export class D365Over75Data {
    @Expose({ name: 'RangeOver75Months' })
    range: string;
}
